import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';

export interface SubmitButtonProps {
    submit;
    loading;
    className?;
    colorType;
    name?;
    value?;
    onChange?;
}

@observer export class SubmitButton extends Component<SubmitButtonProps, any> {

    submit() {
        if (this.props.onChange && this.props.value && this.props.name) {
            this.props.onChange(this.props.value);
        }

        console.log('click submit');

        this.props.submit();
    }

    render() {
        const { submit, loading, className, colorType, name, value } = this.props;

        return <>
            <Button
                name={name}
                value={name}
                color={colorType || 'primary'}
                className={`loading-button ${className || ''}`}
                disabled={loading}
                onClick={() => {
                    this.submit();
                }}
            >
                { this.props.children }
                { loading && <div className={'loading-overlay'}><div className="lds-dual-ring" /></div> }
            </Button>
        </>
    }

}
